import React, { Component } from "react";
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRangePicker, CustomProvider } from 'rsuite';
import enUS from 'rsuite/locales/en_US';
import { callBackendAPI, handleFormValidation, handleFormInputs, generateSource , reFormatErrors} from './../../helpers/common';
import { STATUS_SUCCESS, DATE_RANGE_PICKER_FORMAT, CALENDAR_DATE_TIME_FORMAT } from './../../config/global_constants';
import { translate, formatDate } from './../../helpers/intl_helpers';

const locale = {
  ...enUS,
  DateTimeFormats: {
    ...enUS.DateTimeFormats,
    weekStart: 0 // Sunday
  }
};

export default class ReplaceEmployee extends Component {
	constructor(props) {
		super(props)

		const { skillId, empDetails } = this.props;

		let startDate 	=	empDetails?.min_date 	?	empDetails?.min_date 	:new Date();
		let endDate 	=	empDetails?.max_date 	? 	empDetails?.max_date 	:new Date();

		this.state = {
			errors: {},
			fields: {
				start_date	: 	{value: startDate},
				end_date	: 	{value: endDate},
				date_range 	: 	[new Date(startDate), new Date(endDate)],
				skill_id	: skillId
			},
			submitted: false,
			bulkErrors: null,
			modalType: this.props.modalType,
			
		};

		this.closeModal = this.closeModal.bind(this);
		this.handleFormInputs 	= this.handleFormInputs.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.loadOptions 	  = this.loadOptions.bind(this);
	}

	componentDidMount() {
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");
	}

	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try {
			/** Generate source for cancel token */
			this.source = generateSource();

			let response = await callBackendAPI([{ model: 'calendar', method: 'employeeList', is_project_manager: true, current_page: page, emp_name: inputValue ? inputValue : '' }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.result ? resData.result : [];
			let recordsTotal = resData.recordsTotal ? resData.recordsTotal : 0;
			let completeArray = result.concat(loadedOptions);

			return {
				options: result,
				hasMore: completeArray.length === recordsTotal ? false : true,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/**
	* For manage form submit event
	*
	* @param e 	as 	current form object
	*
	* @return null
	*/
	handleFormSubmit(e){
		e.preventDefault();

		const { empDetails  } = this.props;
		const { date_range, employee_id, reason } = this.state.fields;

		let startDate = (date_range && date_range[0])  ?	formatDate(date_range[0],CALENDAR_DATE_TIME_FORMAT)	:"";
		let endDate = (date_range && date_range[1])  ?	formatDate(date_range[1],CALENDAR_DATE_TIME_FORMAT)		:"";

		/** Api Requested Data **/
		let params = [{
			model					: 	'on_call',
			method					: 	'replace-employee',
			schedule_id				:	empDetails?._id || "",
			skill_id				:	empDetails?.skill_id || "",
			start_date				: 	startDate,
			end_date				:	endDate,
			employee_id				: 	employee_id?.value || "",
			reason					: 	reason?.value || "",
		}];

		/** Validation Rules **/
		let validations = {
			employee_id 	:   {label: translate('on_call.employee_id'), "rules" :["select"] },
			// reason 			:   {label: translate('on_call.reason'), "rules" :["required"] },
		}

		/** Handle validation and api response **/
		handleFormValidation(validations,this.state.fields, params , true,true,true).then(async(response)=>{
			if(!response.success) return this.setState({ errors : response.errors, submitted: false});

			if(response.success && response.data.status === STATUS_SUCCESS) {
				/** Hide loader */
				this.closeModal();
				this.props.handleReplaceModal("",false,{});
			}else if(response.data.message){
				this.setState({ errors: reFormatErrors(response.data.message),submitted: false });
			}
		}).catch(err => console.log(err));
	}

	 /**
	* For update state fields values
	*
	* @param e  	as current field object
	* @param field  as current field name
	*
	* @return null
	*/
	handleFormInputs(e, field){
		let response =	handleFormInputs(e, field, this.state.fields);
		this.setState({ response },()=>{});
	}// end handleFormInputs()

	/** Manage input change event */
	handleChange = (fieldName) => (fieldVal) => {
		this.setState((prevState) => {
			const newFields = { ...prevState.fields, [fieldName]: fieldVal };

			return { fields: newFields };
		});
	};

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.handleReplaceModal("",false,{});
	}// end closeModal()


	render() {
		const { submitted, fields } = this.state;
		const { empDetails } = this.props;

		return <>
			<div 
			className="modal fade on-call-modal d-block show"
			id="addemployeeModalLabel" 
			tabIndex={-1}
			aria-labelledby="replace-employeeModalLabel" 
			aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h2 className="modal-title fs-5" id="replace-employeeModalLabel">{translate("on_call.replace_employee")}</h2>
							<button type="button" className="btn-close" aria-label="Close" onClick={() => this.closeModal()}></button>
						</div>
						<form onSubmit={(event) => this.handleFormSubmit(event, 'ReplaceEmployee')} noValidate>
							<div className="modal-body">
								<div className="row filter-box top-0 mt-3">
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.date_range")} <span className='text-danger'>*</span></label>
											<CustomProvider locale={locale}>
												<DateRangePicker
													value={fields.date_range ? fields.date_range :null}
													format={DATE_RANGE_PICKER_FORMAT}
													size="lg"
													className='form-control input-with-label date-range-picker-common'
													onChange={this.handleChange("date_range")}
													placeholder={translate('reports.search_by_date')}
													cleanable={false}
													ranges={[]}
													editable={false}
													disabled
												/>
											</CustomProvider>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.replace_from")} <span className='text-danger'>*</span></label>
											<input
												id="reason"
												type="text"
												name="reason"
												className="form-control input-with-label"
												placeholder={translate("on_call.reason")}
												defaultValue={empDetails?.name || ""}
												disabled
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.replace_to")} <span className='text-danger'>*</span></label>
											<AsyncPaginate
												className='custom-react-select '
												loadOptions={this.loadOptions}
												value={fields.employee_id ? fields.employee_id : null}
												onChange={this.handleChange("employee_id")}
												isClearable={true}
												placeholder={translate("on_call.select_employee")}
												additional={{ page: 1 }}
											/>
											<span className="error text-danger">{this.state.errors["employee_id"]}</span>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.reason")} </label>
											<textarea type="reason" className="form-control" name='reason' id='reason' value={fields["reason"] ? fields["reason"]["value"] : ""} placeholder={translate("on_call.reason")} onChange={(event) => this.handleFormInputs(event, "reason")}></textarea>
											<span className="error text-danger">{this.state.errors["reason"]}</span>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-outline" data-bs-dismiss="modal" onClick={() => this.closeModal()}>{translate('system.cancel')}</button>
								<button type={submitted ? "button" :"submit"} className="btn btn-fill">
									{translate('system.submit')}{submitted && <i className="spinner-border spinner-border-sm  ms-3"/>}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</>
	}
}